<template>
  <div class="products-edit" v-bind:class="{ splitView: isSplitView }">
    <div class="edit section">
      <b-form @submit="onSubmit" class="inner-section">
        <h1 v-if="newProduct">Produkt bearbeiten</h1>
        <h1 v-else>Produkt hinzufügen</h1>

        <b-alert v-model="showSavingAlert">
          <b-spinner small></b-spinner> Speichern
        </b-alert>

        <b-alert v-model="showSavedAlert" variant="success" dismissible>
          Erfolgreich gespeichert!
        </b-alert>

        <b-alert v-model="showErrorAlert" variant="danger" dismissible>
          Fehler beim speichern!
        </b-alert>

        <b-form-group
          id="input-group-product-name"
          label-for="input-product-name"
          v-b-tooltip.hover
          title="Name">

          <b-form-input
            id="input-product-name"
            v-model="newProduct.name"
            required
            placeholder="Name">
          </b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-product-price"
          label-for="input-product-price"
          v-b-tooltip.hover
          title="Preis">

          <b-form-input
            id="input-product-price"
            v-model="newProduct.price"
            required
            placeholder="Preis">
            </b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-product-link"
          label-for="input-product-link"
          v-b-tooltip.hover
          title="Produktlink">

          <b-form-input
            id="input-product-link"
            v-model="newProduct.link"
            @change="changedLink"
            required
            placeholder="Produktlink">
            </b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-product-image-url"
          label-for="input-product-image-url"
          v-b-tooltip.hover
          title="Produktlink">
          <b-form-input
            id="input-product-image-url"
            v-model="newProduct.image"
            required
            placeholder="Bildlink">
            </b-form-input>
        </b-form-group>

        <RwvImageCropper
          @cropImage="cropImage"
          @deleteImage="deleteImage"
          :targetFolder="'Dk-Products'"
          :srcImage="newProduct.image"
          :index="99">
        </RwvImageCropper>

        <b-button
          v-b-tooltip.hover
          type="submit"
          variant="primary"
          title="Speichert die Daten in der Datenbank">
          Speichern
        </b-button>

        <b-button
          v-b-tooltip.hover
          v-on:click="onReset"
          variant="warning"
          title="Setzt die Seite auf den letzten Stand zurück">
          Zurücksetzen
        </b-button>

        <b-button
          v-b-tooltip.hover
          v-on:click="areYouSure"
          variant="danger"
          title="Löscht das Produkt unwiderruflich">
          Produkt löschen
        </b-button>
      </b-form>
    </div>
    <RwvProductCard class="inner-section" :product="newProduct" :isAuthenticated="true"/>

    <!-- Add Modal 'Are you sure?'' -->
    <b-modal
      ref="modal-are-you-sure"
      title="Wirklich löschen?"
      ok-title="Löschen"
      ok-variant="danger"
      @ok="onDelete"
      cancel-title="Abbrechen">
      <p class="my-4">Das Produkt wird dabei unwiderruflich gelöscht.</p>
    </b-modal>

    <!-- Error Modal -->
    <b-modal id="modal-error" :title="error.name" hide-footer>
      <template slot="modal-title" variant="danger">
        {{error.name}}
      </template>
      <p class="my-4">{{error.message}}</p>

      <b-button v-b-toggle.collapse-1 variant="primary">Mehr Details</b-button>
      <b-collapse id="collapse-1" class="mt-2">
        <b-card>
          <p class="card-text">{{error.stack}}</p>
        </b-card>
      </b-collapse>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import store from "@/store";
import RwvImageCropper from "@/components/ImageCropper";
import RwvProductCard from "@/components/Cards/ProductCard";

import {
  PRODUCT_PUBLISH,
  PRODUCT_EDIT,
  PRODUCT_DELETE,
  PRODUCT_RESET_STATE,
  FETCH_PRODUCT,
  FETCH_PRODUCTS
} from "@/store/actions.type";

export default {
  title () {
    return `Bearb.: ${this.newProduct.slug} | So wird's gemacht`
  },
  components: {
    RwvImageCropper,
    RwvProductCard
  },
  props: {
    previousProduct: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      isSplitView: true,
      newProduct: {},
      srcProduct: {},
      error: {
        title: "",
        message: "",
        stack: ""
      },
      showSavingAlert: false,
      showSavedAlert: false,
      showErrorAlert: false
    }
  },
  async beforeRouteUpdate(to, from, next) {
    // Reset state if user goes from /editor/:id to /editor
    // The component is not recreated so we use to hook to reset the state.
    await store.dispatch(PRODUCT_RESET_STATE);
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    // SO: https://github.com/vuejs/vue-router/issues/1034
    // If we arrive directly to this url, we need to fetch the product
    await store.dispatch(PRODUCT_RESET_STATE);
    if (to.params.slug !== undefined) {
      await store.dispatch(
        FETCH_PRODUCT,
        {
          slug: to.params.slug,
          prevProduct: to.params.previousProduct
        }
      );
    }
    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(PRODUCT_RESET_STATE);
    next();
  },
  watch: {
    // product: {
    //   handler() {
    //     // console.log("in watch product")
    //   },
    //   deep: true
    // }
  },
  computed: {
    ...mapGetters(["product", "products"])
  },
  mounted() {
    // this.fetchProducts()
  },
  created() {
    this.newProduct = this.product;
    this.srcProduct = JSON.parse(JSON.stringify(this.product));
  },
  methods: {
    // fetchProducts() {
    //   this.$store.dispatch(FETCH_PRODUCTS);
    // },
    cropImage(croppedImage) {
      this.newProduct.image = croppedImage
    },
    deleteImage() {
      this.newProduct.image = ""
    },
    changedLink(link) {
      console.log("link")
      console.log(link)
      if (link.includes("http")) {
        this.newProduct.link = link
      } else {
        this.newProduct.link = "http://" + link
      }
    },
    onSubmit(e) {
      var me = this;
      e.preventDefault();
      var slug = me.srcProduct.slug;
      let action = slug ? PRODUCT_EDIT : PRODUCT_PUBLISH;
      // Start Spinner
      me.showSavingAlert = true
      me.newProduct.price = me.newProduct.price

      me.$store
        .dispatch(action)
        .then(({ data }) => {
          this.$bvToast.toast("Die Daten wurden erfolgreich gespeichert!", {
            title: "Gespeichert",
            variant: 'success'
          })
            // toaster: 'b-toaster-top-center'
          me.showSavingAlert = false;
        })
        .catch(({ response }) => {
          me.showSavingAlert = false;
          if (response) {
          console.log(response)
            this.$bvToast.toast(response.data.error.message, {
              title: response.data.error.name,
              variant: 'danger'
            })
          } else {
            this.$bvToast.toast("An unknown Error occured", {
              title: "Unknown Error",
              variant: 'danger'
            })
          }
          // me.$bvModal.show("modal-error")
        });
    },
    onReset() {
      this.newProduct = JSON.parse(JSON.stringify(this.srcProduct));
    },
    areYouSure() {
      this.$refs['modal-are-you-sure'].show()
    },
    onDelete() {
      var me = this;
      me.$store
        .dispatch(PRODUCT_DELETE, me.srcProduct.slug)
        .then(({ data }) => {
          // this.$bvToast.toast("Das Buch wurde gelöscht!", {
          //   title: "Gelöscht",
          //   variant: 'success'
          // })
          this.$router.push({ name: "dashboard" });
        })
        .catch(({ response }) => {
          if (response) {
            console.log(response)
            this.$bvToast.toast(response.data.error.message, {
              title: response.data.error.name,
              variant: 'danger'
            })
          } else {
            this.$bvToast.toast("An unknown Error occured", {
              title: "Unknown Error",
              variant: 'danger'
            })
          }
        });
    },
  },
}
</script>


<style lang="scss">
</style>
